// default page size for paginated api responses
const LIST_DEFAULT_PAGE_SIZE = 20;
const SEARCH_QUERY_MIN_LENGTH = 3;

export {LIST_DEFAULT_PAGE_SIZE, SEARCH_QUERY_MIN_LENGTH};
